import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { Appearance } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/rst/common/appearance';
export default ProtoBaseModel.extend({
  userInterfaceStyle: attr(Appearance.UserInterfaceStyle)
});